<template>
  <div class="wrapp-all">
    <div class="main-container">
      <unfolding-table :data="tables" />
      <div class="write-sql sql-query-container">
        <label for="" style="height: 60px">
          <p><b>Przykład:</b></p>
          <p style="font-size: 10px">
            select u.id, u.phone, p.first_name, p.last_name from users u inner
            join profiles p on p.user_id = u.id
          </p>
        </label>
        <textarea
          placeholder="Miejsce na wpisanie SQL..."
          name=""
          id=""
          cols="60"
          rows="10"
          v-model="sql"
        ></textarea>
        <button
          class="btn btn-outline-dark"
          type="submit"
          style="margin-top: 20px; padding: 0 10px"
          @click="generateReport"
        >
          Generuj
        </button>
      </div>
      <div class="write-sql note-container">
        <label for="" style="height: 60px">
          <p><b>Notatnik</b></p>
          <p style="font-size: 10px">Maksymalna liczba znaków: 16000</p>
        </label>
        <textarea
          placeholder="Notatnik"
          name="note-textarea"
          id=""
          cols="100"
          rows="10"
          v-model="note"
          maxlength="16000"
        ></textarea>
        <button
          class="btn btn-outline-dark"
          type="submit"
          style="margin-top: 20px; padding: 0 10px"
          @click="saveNote"
        >
          Zapisz
        </button>
      </div>
    </div>
    <div
      id="sql-report"
      v-if="showReport"
      style="margin-top: 20px"
      class="generated-report"
    >
      <div
        style="display: flex; align-items: center; justify-content: center"
        class="report-header"
      >
        <h1>Wygenerowany Report</h1>
        <button
          class="btn btn-outline-dark"
          type="submit"
          style="margin-top: -17px; padding: 0 10px; margin-left: 20px"
          @click="downloadReport"
        >
          Pobierz
        </button>
      </div>

      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th v-for="key in report.columns" :key="key">{{ key }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in report.rows" :key="index">
            <td v-for="key in report.columns" :key="key">{{ row[key] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import UnfoldingTable from "../../components/UnfoldingTable.vue";
import axios from "../../axios";
export default {
  components: { UnfoldingTable },
  data() {
    return {
      showReport: false,
      report: {
        columns: [],
        rows: [],
      },
      tables: [],
      sql: "",
      note: "",
    };
  },

  watch: {
    sql() {
      if (this.sql) {
        const sqlLowerCase = this.sql.toLowerCase();
        const forbiddenKeywords = [
          "alter",
          "delete",
          "update",
          "insert",
          "drop",
          "truncate",
          "grant",
          "revoke",
        ];
        const regex = new RegExp(
          `\\b(${forbiddenKeywords.join("|")})\\b`,
          "gi"
        );

        if (sqlLowerCase.match(regex)) {
          this.$notify({
            group: "error",
            text: "Zapytanie zawiera niedozwolone słowo kluczowe",
          });

          this.sql = this.sql.replace(regex, "");
        }
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("fetchDatabaseTables");
    await this.$store.dispatch("fetchSqlReportNote");
    this.tables = this.databaseTables.map((databaseTable, index) => {
      return {
        id: index + 1,
        name: databaseTable.name,
        unfolded: false,
        columns: databaseTable.columns,
      };
    });

    if (this.savedNote && this.savedNote.text) {
      this.note = this.savedNote.text;
    }
  },
  methods: {
    async saveNote() {
      const response = await this.$store.dispatch("editSqlReportNote", {
        text: this.note,
      });
      if (response) {
        this.$notify({
          group: "success",
          text: "Notatka zapisana",
        });
      } else {
        this.$notify({
          group: "error",
          text: "Nie udało się zapisać notatki",
        });
      }
    },
    checkMinimum2Parameters(sql) {
      //eslint-disable-next-line
      const pattern = /select\s+([\w\*,\s]+)\s+from/i;
      const cleanedSql = sql.replace(/\./g, "");

      const matches = cleanedSql.match(pattern);

      if (matches) {
        const columns = matches[1].split(",").map((c) => c.trim());
        if (columns.length >= 2) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    async generateReport() {
      if (
        !this.sql.includes("count") &&
        !this.checkMinimum2Parameters(this.sql)
      ) {
        this.$notify({
          group: "error",
          text: "Wymagane jest wybranie minimum dwóch kolumn do wyświetlenia wyniku zapytania",
        });
        return;
      }
      if (!this.sql) {
        this.$notify({
          group: "error",
          text: "Wprowadź zapytanie SQL",
        });
        return;
      }
      const response = await this.$store.dispatch("generateSqlReport", {
        sql: this.sql,
      });
      if (response) {
        this.showReport = true;
        if (this.generatedReport[0]) {
          this.report.columns = Object.keys(this.generatedReport[0]);
          this.report.rows = this.generatedReport;
          this.lastGeneratedSql = this.sql;
        }

        setTimeout(() => {
          document
            .getElementById("sql-report")
            .scrollIntoView({ behavior: "smooth" });
        }, 500);
      } else {
        this.showReport = false;
        this.$notify({
          group: "error",
          text: "Nie udało się wykonać zapytania. Sprawdź czy zapytanie jest na pewno bez żadnych błędów",
        });
        this.report = {
          columns: [],
          rows: [],
        };
      }
    },

    async downloadReport() {
      try {
        const params = new URLSearchParams();
        params.append("sql", this.lastGeneratedSql);
        const url = `/api/admin/database-tables/report/file`;
        const response = await axios(url, {
          method: "GET",
          headers: {
            "Content-Disposition": "attachment; filename=sqlReport.xls",
            "Content-Type":
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          },
          responseType: "blob",
          params,
        });
        if (response) {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sqlReport.xls");
          document.body.appendChild(fileLink);
          fileLink.click();
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          group: "error",
          text: "Nie udało się pobrać raportu",
        });
      }
    },
  },

  computed: {
    generatedReport() {
      return this.$store.getters["getSqlReport"];
    },

    databaseTables() {
      return this.$store.getters["getDatabaseTables"];
    },

    savedNote() {
      return this.$store.getters["getSqlReportNote"];
    },
  },
};
</script>

<style scoped>
.main-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.write-sql {
  display: flex;
  flex-direction: column;
  width: 520px;
}
textarea:focus {
  outline: none;
}
textarea {
  font-size: 13px;
}

@media (max-width: 1271px) {
  .note-container {
    order: 2;
  }
  .sql-query-container {
    order: 3;
  }
}
</style>
